/**
 * Symbol Normalizer Utility
 * Converts complex symbol strings to simplified format
 */

/**
 * Normalizes a symbol string by extracting the last part after dots
 * @param {string} symbol - The symbol to normalize (e.g., "0000001.FX.AUDCAD")
 * @returns {string} - The normalized symbol (e.g., "AUDCAD")
 */
export const normalizeSymbol = (symbol) => {
  if (!symbol || typeof symbol !== 'string') {
    return symbol;
  }
  
  // Split by dots and return the last part
  const parts = symbol.split('.');
  return parts[parts.length - 1] || symbol;
};

/**
 * Gets both the original and normalized symbol
 * @param {string} symbol - The symbol to process
 * @returns {object} - Object containing original and normalized symbols
 */
export const getSymbolInfo = (symbol) => {
  return {
    original: symbol,
    normalized: normalizeSymbol(symbol)
  };
};